




















import Vue from 'vue'
import mkInfoData from '@/components/Google/SelectedMarker/InfoData'
import { Position } from '@/components/Map/types'
import { apiGetAddress } from '@/api'

export default Vue.extend({
  name: 'InformationPane',
  props: {
    marker: Object,
    entity: Object
  },
  computed: {
      infoData (): any[] {
        return mkInfoData(this.entity, this.address, this.activity, this.t)
      }
    },
  data () {
    return {
      address: '',
      activity: ''
    }
  },
  methods: {
    setAddress (position: Position): void {
      if (!position) return
      apiGetAddress(position).then((res) => {
        this.address = res.data.data.address
      }).catch(e => console.log(e.response.data.message))
    },
    setActivity (date: String): void {
      if (date) {
        this.activity = this.$moment.utc(date).fromNow()
      }
      if (this.activityInterval) {
        clearInterval(this.activityInterval)
      }
      this.activityInterval = setInterval(() => {
        this.activity = this.$moment.utc(date).fromNow()
      }, 10000)
    }
  },
  mounted () {
    const { received_at, positioned_at, position } = this.marker
    this.setActivity(positioned_at || received_at)
    this.setAddress(position)
  },
  watch: {
    marker: {
      deep: true,
      handler (m) {
        this.setAddress(m.position)
        this.setActivity(m.positioned_at || m.received_at)
      }
    }
  }
})
